import React from 'react';
import { Box } from '@wix/design-system';
import styles from './TldPromotion.scss';
import { TldPromotionContent } from './TldPromotionContent';
export const TldPromotionComp = _ref => {
  let tld = _ref.tld,
    pricing = _ref.pricing,
    description = _ref.description,
    id = _ref.id,
    Label = _ref.Label,
    PromotionBadge = _ref.PromotionBadge,
    PromotionPrice = _ref.PromotionPrice;
  return /*#__PURE__*/React.createElement(Box, {
    key: id,
    padding: "SP2 45px",
    direction: "vertical",
    gap: "SP4",
    minHeight: "205px",
    align: "space-between",
    position: "relative",
    className: styles.gridItem
  }, /*#__PURE__*/React.createElement(TldPromotionContent, {
    tld: tld,
    pricing: pricing,
    description: description,
    Label: Label,
    PromotionBadge: PromotionBadge,
    PromotionPrice: PromotionPrice
  }));
};
//# sourceMappingURL=TldPromotion.js.map